import React from "react";

export const CustomTabPanel = ({ id, tabValue, tabIndex, children }) => {
  return (
    <div id={id} role={"tabpanel"} hidden={tabValue !== tabIndex}>
      {children}
    </div>
  );
};
